import './App.css';

import { useCookies } from 'react-cookie';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import AboutUs from './AboutUs.js';
import Baa from './Baa.js';
import Case from './Case.js';
import Chdpp from './Chdpp.js';
import ExecuteBaa from './ExecuteBaa.js';
import ColorPaletteShowcase from './ColorPaletteShowcase.js';
import ContactUs from './ContactUs.js';
import DocumentProcessing from './DocumentProcessing';
import Home from './Home.js';
import { logout as logoutUtil } from './LoginUtils.js';
import MyCases from './MyCases.js';
import Press from './Press.js';
import PressRelease from './PressRelease.js';
import Pricing from './Pricing.js';
import Privacy from './Privacy.js';
import ScrollToTop from './ScrollToTop.js';
import SecurityPrivacy from './SecurityPrivacy.js';
import Terms from './Terms.js';
import { useInactivityTimer } from './useInactivityTimer.js';

/**
 * Inner component that has access to Router context for useLocation hook
 */
function AppContent() {
  const location = useLocation();
  const [cookies, , removeCookie] = useCookies(['credential']);

  // Setup inactivity timer for HIPAA compliance
  useInactivityTimer({
    isAuthenticated: !!cookies.credential,
    onLogout: () => {
      logoutUtil(removeCookie, null);
    },
    location
  });

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route exact path='/mycases' element={<MyCases />} />
        <Route exact path='/case/:caseId' element={<Case />} />
        <Route exact path='/document_processing' element={<DocumentProcessing />} />
        <Route exact path='/contact' element={<ContactUs />} />
        <Route exact path='/about' element={<AboutUs />} />
        <Route exact path='/pricing' element={<Pricing />} />
        <Route exact path='/security' element={<SecurityPrivacy />} />
        <Route exact path='/privacy' element={<Privacy />} />
        <Route exact path='/terms' element={<Terms />} />
        <Route exact path='/press' element={<Press />} />
        <Route exact path='/press/:slug' element={<PressRelease />} />
        <Route exact path='/baa' element={<Baa />} />
        <Route exact path='/execute-baa' element={<ExecuteBaa />} />
        <Route exact path='/chdpp' element={<Chdpp />} />
        <Route exact path='/color-palette-showcase' element={<ColorPaletteShowcase />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}


export default App;
